import type {
  ActiveSeasonView,
  GlobalActiveSeasonView,
} from '@multirx/shared/types/championship.js';

/** Id de référence d’une saison globale (D1, sinon le plus petit id des divisions). */
export function resolveGlobalSeasonTitleId(globalView: GlobalActiveSeasonView): number | null {
  const d1 = globalView.divisions[1]?.season.id;
  if (d1 != null) return d1;
  const ids = Object.values(globalView.divisions)
    .filter((v): v is ActiveSeasonView => v != null)
    .map((v) => v.season.id);
  if (ids.length === 0) return null;
  return Math.min(...ids);
}

/** Titre du panneau championnat : « Saison {id} de rallycross ». */
export function formatChampionshipSeasonTitle(seasonId: number): string {
  return `Saison ${seasonId} de rallycross`;
}

export function championshipPanelTitle(
  globalView: GlobalActiveSeasonView | null,
  fallback = 'Championnat rallycross'
): string {
  if (!globalView) return fallback;
  const id = resolveGlobalSeasonTitleId(globalView);
  if (id == null) return fallback;
  return formatChampionshipSeasonTitle(id);
}
